import React, { ReactNode } from 'react';
import { Button, DialogTitle, DialogContent, DialogActions, 
  Dialog, DialogProps, Typography, useTheme, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface InsufficientPermissionsDialogProps extends DialogProps {
  // Optional descriptive text to display below the title.
  // Alternately, you can pass children to display custom JSX
  description?: string | ReactNode;

  // Optional custom confirmation button text
  confirmText?: string | ReactNode;
}

export default function InsufficientPermissionsDialog(props: InsufficientPermissionsDialogProps) {
  const theme = useTheme();
  const { i18n } = useTranslation();
  const { confirmText, title, onClose, open, ...otherProps } = props;

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className='drag-cancel'
      fullScreen={isSmallScreen}
      {...otherProps}
      onClick={(event) => {
        event.stopPropagation();
        const className = (event.target as any).className;
        if (onClose && className?.startsWith && className.startsWith("MuiDialog-container")) {
          onClose(event, "backdropClick");
        }
      }}
    >
      <DialogTitle sx={{ minWidth: "400px" }}>
        <Typography variant="h3">
          {title || i18n.t("account-status.insufficient-permissions")}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1">
          {props.description || i18n.t("account-status.insufficient-account-permissions")}
        </Typography>
        {props.children}
      </DialogContent>
      <DialogActions sx={{ padding: "10px 18px 10px 0" }} >
        <Button 
          variant="contained"
          color='success'
          size="small"
          onClick={(event) => {              
            onClose && onClose(event, "backdropClick")
          }} >
          { confirmText || i18n.t("close") }
        </Button>
      </DialogActions>
    </Dialog>
  );
}
